import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "weather",
  class: "app-system-weather"
}

import {
  onMounted,
  ref,
  withDefaults,
  watch,
  computed,
  nextTick,
} from 'vue'

interface Props {
  /**
   * 面板背景色，默认值 #3d3e40
   */
  background?: string
  /**
   * 天气插件KEY，和风插件，默认值：5bde1a64fe674a218516f8a3d4f3f64d
   */
  // eslint-disable-next-line camelcase
  hfKey?: string
  /**
   * 城市成名，默认值为 undefined，代表自动获取位置
   */
  city?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'app-system-weather',
  props: {
    background: { default: '#3d3e40' },
    hfKey: { default: '5bde1a64fe674a218516f8a3d4f3f64d' },
    city: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { background: string, hfKey: string, city: string }


const city = computed(() => props.city)
const frame = ref<HTMLIFrameElement>()
const endScript = window.atob('PC9zY3JpcHQ+')
const cScript = (js: string) => `<script>${js}${endScript}`
const wScript = () => `<script src="https://widget.qweather.net/standard/static/js/he-standard-common.js?v=2.0">${endScript}`
/**
 * 更新城市信息时，刷新天气列表
 */
watch(
  city,
  async (val) => {
    await nextTick()
    const { background, hfKey } = props
    const cityStr = city.value ? `"city": "${city.value}",` : ''
    const doc = frame.value?.contentDocument?.open()
    doc?.write(
      `<style>html,body{margin: 0;padding: 0;background: ${background};}</style>`,
    )
    doc?.write('<div id="he-plugin-standard"></div>')
    doc?.write(
      cScript(`WIDGET = {
  "CONFIG": {
    "layout": "2",
    "width": 230,
    "height": 270,
    "background": "4",
    "dataColor": "FFFFFF",
    "backgroundColor": "${background}",
    "borderRadius": "6",
    ${cityStr}
    "key": "${hfKey}"
  }
}`),
    )
    doc?.write(wScript())
    doc?.close()
  },
  {
    immediate: true,
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      ref_key: "frame",
      ref: frame
    }, null, 512)
  ], 512))
}
}

})